import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { ReviewSummary } from '../models/review-summary.model';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-review-overview',
  templateUrl: './review-overview.component.html',
  styleUrls: ['./review-overview.component.scss']
})
export class ReviewOverviewComponent implements OnInit {
  @Input() reviewSummary: ReviewSummary;
  @Input() sizeModifier = '';
  @Input() noReviewsText = 'No reviews';
  @Input() isHeader = true;
  @Output() sortReviewsBy = new EventEmitter<string>();
  sortBy = new FormControl();

  ngOnInit(): void {
    this.sortBy.setValue('likes');
  }

  get ratingLabel(): string {
    const count = this.reviewSummary.countRatings;
    const suffix = (count === 1) ? '' : 's';
    return `${count} rating${suffix}`;
  }

  get reviewLabel(): string {
    const count = this.reviewSummary.countReviews;
    const suffix = (count === 1) ? '' : 's';
    return `${count} review${suffix}`;
  }

  reSort (sortBy: string) {
    this.sortReviewsBy.emit(sortBy);
  }
}
